<app-widget-card-wrapper [title]="chartTitle" [hide]="false">
  <div class="card-stretch text-center">
    <div *ngIf="chartOptions" [id]="id" echarts [options]="chartOptions" style="max-height: 350px"></div>
  </div>
</app-widget-card-wrapper>
